import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { motion, AnimatePresence } from "framer-motion";

export default function CombinedChart() {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    chartInstanceRef.current = new Chart(ctx, {
      type: "bar",
      data: {
        labels: [
          "10th Grade [2018-2019]",
          "Intermediate [2019-2021]",
          "B.Tech [2021-2025]",
        ],
        datasets: [
          {
            label: "10th Grade [2018-2019]",
            data: [10, NaN, NaN],
            yAxisID: "gpa",
            backgroundColor: "#00A86B99",
            borderColor: "#00A86B",
            borderWidth: 3,
          },
          {
            label: "Intermediate [2019-2021]",
            data: [NaN, 976, NaN],
            yAxisID: "marks",
            backgroundColor: "#82458166",
            borderColor: "#824581",
            borderWidth: 3,
          },
          {
            label: "B.Tech [2021-2025]",
            data: [NaN, NaN, 9.38],
            yAxisID: "gpa",
            backgroundColor: "#00BBFF99",
            borderColor: "#00BBFF",
            borderWidth: 3,
          },
        ],
      },
      options: {
        scales: {
          gpa: {
            position: "left",
            suggestedMax: 10,
            suggestedMin: 5,
            min: 5,
            title: {
              display: true,
              text: "GPA/CGPA",
              color: "#00A86B",
            },
            grid: {
              color: "#00A86B33",
            },
          },
          marks: {
            position: "right",
            suggestedMax: 1000,
            suggestedMin: 500,
            min: 500,
            title: {
              display: true,
              text: "Marks",
              color: "#00A86B",
            },
            grid: {
              drawOnChartArea: false,
            },
            ticks: {
              color: "#00A86B",
            },
          },
          x: {
            title: {
              display: true,
              text: "Education Levels",
              color: "#00A86B",
            },
            ticks: {
              color: "#00A86B",
            },
            grid: {
              color: "#00A86B33",
            },
          },
        },
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "top",
            labels: {
              color: "#00A86B",
            },
          },
        },
        animation: {
          duration: 1000,
          easing: "easeInQuad",
        },
      },
    });

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        exit={{ y: 40, opacity: 0 }}
        className="lc-center cb-chart"
      >
        <canvas className="linechart" ref={chartRef} />
      </motion.div>
    </AnimatePresence>
  );
}
